import AzureImg from '../../../assets/images/itm-azure-1.png';
import CybersecurityImg from '../../../assets/images/itmonkeys-cyber-landing.png';
import { Service } from './types'
import CloudServiceImg from '../../../assets/images/itmonkeys-infra-cloud.png';
import SynologyImg from '../../../assets/images/itmonkeys-synology.png';
import TrainingImg from '../../../assets/images/itmonkeys-cyber-landing.png';
import CyberEye from '../../../assets/images/dataguard.png';
import Cyberlock from '../../../assets/images/cyber icon.png'
import CyberImg from '../../../assets/images/audit-icon.png'

export const services: Service[] = [
  {
    id: 1,
    icon: CyberImg,
    alt: 'Azure Icon',
    title: 'Audits de cybersécurité',
    subtitle: 'Évaluation et recommandations.',
    description: 'Renforcez la sécurité de votre entreprise avec nos écurité.',
    link: '/cyberaudit',
  },
  {
    id: 3,
    icon: Cyberlock,
    alt: 'Cyber IT Monkeys',
    title: 'Réponse aux incidents',
    subtitle: 'Soyez accompagnés.',
    description: 'Notre équipe intervient rapidement pour limiter les impacts et restaurer vos services.',
    link: '/cyberincident',
  },
  {
    id: 4,
    icon: CyberEye,
    alt: 'Leaks Data guard',
    title: 'Data Leaks Sentinel',
    subtitle: 'Protection contre les fuites de données.',
    description: 'Nous surveillons la divulgation de vos informations sensibles en temps réel.',
    link: '/sentinel',
  }
];
